<template>
  <div class="container flex-ac flex-sb">
    <div class="title flex-ac">
      <h1 class="font7">{{ adminName }}</h1>
    </div>
    <div class="router flex-end flex-ac" style="flex: 1">
      <div class="nav1 flex-ac" v-for="(it, i) in nav" :key="i">
        <div
          :class="
            tabsOn && tabsOn.meta && tabsOn.meta.icon == it.meta.icon
              ? 'tabsOn'
              : 'tabsOn_no'
          "
          @click="handleClick(it)"
          class="nav1_title"
        >
          {{ it.name }}
        </div>
        <template v-if="it.children && it.children.length > 0">
          <div class="nav2">
            <div
              v-for="(item, ind) in it.children"
              @click="handleClick(item)"
              :key="ind + 'c'"
            >
              {{ item.name }}
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="flex-ac">
      <!-- <span style="margin-right: 10px" class="">{{ nowTime }}</span> -->
      <el-popover
        placement="top-start"
        title=""
        width="50"
        trigger="hover"
        :popper-class="'userPopover'"
      >
        <template v-for="(it, i) in btnList">
          <div
            :key="i"
            class="btnList"
            @click="btnClick(it)"
            v-if="
              it.name != '修改密码'
                ? true
                : it.name == '修改密码' &&
                  permissionCodes.indexOf('system.changePassword') > -1
                ? true
                : false
            "
          >
            {{ it.name }}
          </div>
        </template>
        <div slot="reference" class="flex-ac">
          <el-avatar :size="20" :src="circleUrl"></el-avatar>
          <span class="userInfoName flex-ac">{{
            userInfo ? userInfo.user.realName || "" : ""
          }}</span>
          <i class="el-icon-caret-bottom" style="color: #999"></i>
        </div>
      </el-popover>
    </div>
    <el-dialog
      title="修改密码"
      :visible.sync="dialogVisible_changePassword"
      :close-on-click-modal="false"
      :append-to-body="true"
      class="changePwd"
    >
      <el-form :label-position="'right'"         :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        v-if="dialogVisible_changePassword"
      >
        <el-form-item label="当前密码：" prop="passwordOld">
          <el-input
            clearable
            size="mini"
            style="width: 200px"
            v-model="ruleForm.passwordOld"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码：" prop="passwordNew">
          <el-input
            clearable
            size="mini"
            style="width: 200px"
            v-model="ruleForm.passwordNew"
            show-password
            :maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div class="changePwdTips">
            <p class="flex-ac flex-start">
              <i
                class="el-icon-lock"
                style="margin-right: 5px"
                :style="{
                  color:
                    ruleForm.passwordNew == ''
                      ? '#999'
                      : changePwd_qd <= 1
                      ? 'rgba(245, 115, 115, 1)'
                      : changePwd_qd == 2
                      ? 'rgb(251, 220, 100)'
                      : changePwd_qd == 3
                      ? 'rgb(83, 208, 163)'
                      : '#ddd',
                }"
              />
              安全等级：<span
                v-for="i in 3"
                :key="i"
                :style="setPwdLevelStyle(i)"
                style="
                  width: 18px;
                  height: 10px;
                  border-radius: 2px;
                  margin-right: 4px;
                  background: #ddd;
                "
              /><b
                :style="{
                  color:
                    ruleForm.passwordNew == ''
                      ? '#999'
                      : changePwd_qd == 1
                      ? 'rgba(245, 115, 115, 1)'
                      : changePwd_qd == 2
                      ? 'rgb(251, 220, 100)'
                      : changePwd_qd == 3
                      ? 'rgb(83, 208, 163)'
                      : '#fff',
                }"
                >{{
                  changePwd_qd == 1
                    ? "弱"
                    : changePwd_qd == 2
                    ? "中"
                    : changePwd_qd == 3
                    ? "强"
                    : ""
                }}</b
              >
            </p>
            <p>
              <i
                :class="
                  'el-icon-circle-' + (!changePwd_gz1 ? 'close' : 'check')
                "
                style="margin-right: 5px"
                :style="{
                  color:
                    ruleForm.passwordNew == ''
                      ? '#999'
                      : !changePwd_gz1
                      ? 'rgba(245, 115, 115, 1)'
                      : 'rgb(83, 208, 163)',
                }"
              />密码由8~20位组成
            </p>
            <p>
              <i
                :class="
                  'el-icon-circle-' + (!changePwd_gz2 ? 'close' : 'check')
                "
                style="margin-right: 5px"
                :style="{
                  color:
                    ruleForm.passwordNew == ''
                      ? '#999'
                      : !changePwd_gz2
                      ? 'rgba(245, 115, 115, 1)'
                      : 'rgb(83, 208, 163)',
                }"
              />密码必须包含字母、数字、非空字符
            </p>
          </div>
        </el-form-item>
        <el-form-item label="确认密码：" prop="confirmPassword">
          <el-input
            clearable
            size="mini"
            style="width: 200px"
            v-model="ruleForm.confirmPassword"
            show-password
            :maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            size="mini"
            @click="resetForm('ruleForm')"
            style="width: 93px"
            >重置</el-button
          >
          <el-button
            size="mini"
            type="primary"
            @click="submitForm('ruleForm')"
            style="width: 93px"
            :disabled="
              changePwd_qd == 3 &&
              ruleForm.passwordNew == ruleForm.confirmPassword
                ? false
                : true
            "
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { changePassword } from "@/api/system";
import { Logout } from "@/api/auth";
import { mapGetters } from "vuex";
export default {
  components: {},
  computed: {
    ...mapGetters([
      "tabsList",
      "tabsOn",
      "userInfo",
      "rasPublicKey",
      "permissionCodes",
      "nav",
    ]),
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.confirmPassword !== "") {
          this.$refs.ruleForm.validateField("confirmPassword");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入新密码"));
      } else if (value !== this.ruleForm.passwordNew) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      adminName: "",
      btnList: [
        // { name: "个人信息", path: "" },
        { name: "修改密码", path: "" },
        { name: "注销登录", path: "" },
      ],
      circleUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      nowTime: "",
      dialogVisible_changePassword: false,
      changePwd_qd: 0,
      ruleForm: {
        passwordOld: "",
        passwordNew: "",
        confirmPassword: "",
      },
      rules: {
        passwordOld: [
          { message: "请输入当前密码", trigger: "blur", required: true },
        ],
        passwordNew: [
          { validator: validatePass, trigger: "blur", required: true },
        ],
        confirmPassword: [
          { validator: validatePass2, trigger: "blur", required: true },
        ],
      },
      changePwd_gz1: false,
      changePwd_gz2: false,
    };
  },
  watch: {
    dialogVisible_changePassword() {
      this.ruleForm = {
        passwordOld: "",
        passwordNew: "",
        confirmPassword: "",
      };
    },
    "ruleForm.passwordNew"(v) {
      var changePwd_qd = 0;
      this.changePwd_qd = 0;
      if (v.length >= 8 && v.length <= 20) {
        changePwd_qd = 0;
        if (/\d/.test(v)) changePwd_qd++; //数字
        if (/[A-z]/.test(v)) changePwd_qd++; //字母
        if (/\W/.test(v)) changePwd_qd++; //特殊字符
      }
      this.changePwd_qd = changePwd_qd;

      this.changePwd_gz1 = v.length >= 8 && v.length <= 20;
      this.changePwd_gz2 = /\d/.test(v) && /[A-z]/.test(v) && /\W/.test(v);
    },
    tabsOn(v){
      if(v)this.handleClick(v);
    }
  },
  mounted() {
    this.adminName = window.SystemInfo.title;
    this.$bus.$on("headerRouter", (it) => {
      this.handleClick(it);
    });
    if (!this.userInfo) {
      this.$store.dispatch("store/setUserInfo", null);
      this.$store.dispatch("store/setTabsOn", null);
      this.$store.dispatch("store/setTabsList", []);
      localStorage.removeItem("userInfo");
      this.$router.push({ path: "/login" });
    }
    this.handleClick({
      path: "home",
      component: "/home/index",
      name: "首页",
      redirect: "",
      children: [],
      meta: { icon: "home" },
    });
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    setPwdLevelStyle(i) {
      if (this.changePwd_qd == 0) {
        return {
          background: "#ddd",
        };
      }
      if (this.changePwd_qd == 1 && i <= 1) {
        return {
          background: "rgba(245, 115, 115, 1)",
        };
      }
      if (this.changePwd_qd == 2 && i <= 2) {
        return {
          background: "rgb(251, 220, 100)",
        };
      }
      if (this.changePwd_qd == 3 && i <= 3) {
        return {
          background: "rgb(83, 208, 163)",
        };
      }
    },
    submitForm(formName = "ruleForm") {
      const _this = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const jsRsa = new this.$jsEncrypt();
          jsRsa.setPublicKey(this.rasPublicKey);
          let data = {
            passwordOld: jsRsa.encrypt(this.ruleForm.passwordOld),
            passwordNew: jsRsa.encrypt(this.ruleForm.passwordNew),
            confirmPassword: jsRsa.encrypt(this.ruleForm.confirmPassword),
          };
          changePassword(data).then((res) => {
            if (res.code == 401) {
              this.$config.getNewToken(this, () => {
                _this.submitForm();
              });
            } else {
              if (res.result == 2) {
                this.$notify({
                  message: "当前密码错误",
                  type: "info",
                  title: "成功",
                  position: "bottom-right",
                });
              } else if (res.result == 0) {
                this.$notify({
                  message: "修改成功，需要重新登陆",
                  type: "success",
                  title: "提示",
                  position: "bottom-right",
                });
                localStorage.removeItem("userInfo");
                setTimeout(() => {
                  this.logout();
                }, 2000);
              }
            }
          });
        }
      });
    },
    handleClick(it) {
      if (!it) debugger;
      if (it.name == "修改密码") {
        this.dialogVisible_changePassword = true;
        return;
      }
      // console.log(it);
      // if (it && it.path == "auditDayDatas" && it.date) {
      //   this.$store.dispatch("store/setAuditCalendar_queryDate", it.date);
      // }
      if (it && it.path == "operationMaintenanceRecord" && it.date) {
        this.$store.dispatch("store/setYwjl_queryDate", it.date);
      }
      if (!it.children || it.children.length == 0) {
        console.log(
          "进入pages-  ",
          it.name,
          it.path,
          it.meta.permission,
          it.meta.icon
        );
        let list = JSON.parse(JSON.stringify(this.tabsList));
        let tabs = this.tabsList.filter((v) => v.path == it.path);
        if (!list[0] || !tabs[0]) {
          list.push(it);
        }
        this.$store.dispatch("store/setTabsOn", it);
        this.$store.dispatch("store/setTabsList", list);
      } else {
        console.log("进入分类-  ", it.name, it.path);
      }
    },
    btnClick({ name, path }) {
      if (name == "注销登录") {
        this.logout();
      }
      if (name == "修改密码") {
        this.handleClick({
          path: "changePassword",
          name: "修改密码",
          redirect: "",
          children: [],
          meta: { icon: "system" },
        });
      }
    },
    logout() {
      const _this = this;
      Logout().then((res) => {
        if (res.code == 401) {
          this.$config.getNewToken(this, () => {
            _this.logout();
          });
        } else {
          this.$notify({
            position: "bottom-right",
            title: "成功",
            message: "正在注销",
            type: "success",
          });
          setTimeout(() => {
            this.$store.dispatch("store/setUserInfo", null);
            this.$store.dispatch("store/setTabsOn", null);
            this.$store.dispatch("store/setTabsList", []);
            localStorage.removeItem("userInfo");
            this.$router.push({ path: "/login" });
          }, 1000);
        }
      });
    },
  },
  destroyed() {
    // this.$bus.$off("headerRouter");
  },
};
</script>
<style lang="stylus" scoped>
.container {
  padding: 0 20px;
  box-sizing: border-box;
  height: 64px;
  position: relative;
  z-index: 1;
  box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.06);

  .title {
    img {
      height: 25px;
    }

    h1 {
      margin: 0 10px;
      font-size: 28px;
      color: #000;
      // font-family: 'font7';
      font-weight: 700;
    }
  }
}

.userInfoName {
  margin-left: 10px;
  color: #999;
  margin-right: 5px;
  font-size: 14px;
  cursor: pointer;
}

.btnList {
  padding: 5px 0;
  font-size: 14px;
  cursor: pointer;
  padding: 0 14px;
  line-height: 40px;

  &:hover {
    background: rgba(17, 130, 251, 0.1);
  }
}

.el-icon-switch-button {
  color: rgba(0, 0, 0, 0.8);
  cursor: pointer;
  font-size: 16px;
  margin-left: 10px;
}

.el-icon-switch-button:hover {
  color: red;
}

.router {
  padding-right: 45px;
  height: 80%;
}

.nav1 {
  padding: 0 15px;
  cursor: pointer;
  position: relative;
  height: 100%;
}

.nav1_title {
  font-size: 18px;
  font-weight: 400;
}

.nav2 {
  display: none;
  position: absolute;
  top: 100%;
  width: 170px;
  left: 0;
  // transform: translate(-50%, 0);
  background: #fff;
  border-radius: 0px 0px 4px 4px;
  padding: 6px 0;

  >div {
    padding: 0 14px;
    line-height: 40px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
  }
}

.nav2>div:hover {
  background: rgba(17, 130, 251, 0.1);
}

.nav1:hover {
  >div {
    color: #000;
    // font-weight: 600;
  }

  .nav2 {
    display: block;
  }
}

.nav2:before {
  background: rgba(0, 0, 0, 0.1);
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: -1;
  left: 0;
  content: '';
  border-radius: 0px 0px, 4px, 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 7px 10px 0px rgba(0, 0, 0, 0.1);
}

.tabsOn:after {
  content: '';
  width: 20px;
  height: 6px;
  opacity: 1;
  border-radius: 3px;
  background: rgb(17, 130, 251);
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  top: 40px;
  z-index: 1;
}

.tabsOn_no {
  color: #999;
}

.tabsOn {
  color: #1182fb;
}
</style>
<style>
.userPopover {
  padding: 6px 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/headerComp copy.vue